// Centralized session storage helpers — used by api.js, auth.jsx, AuthCallback.
// Keeps the list of auth keys in ONE place so a logout / 401 / login flow
// always wipes the same set.

const AUTH_LOCAL_KEYS = ["nv_jwt"];
// Defensive: also wipe any legacy keys that may have been used in older builds
const LEGACY_AUTH_KEYS = ["jwt", "auth_token", "user", "nv_user"];

export function getJwt() {
  try {
    return localStorage.getItem("nv_jwt");
  } catch (err) {
    // Browser blocks storage access (private-browsing or strict tracking
    // protection). Surface it for diagnostics; treat as unauthenticated.
    // eslint-disable-next-line no-console
    console.warn("session.getJwt: storage unavailable —", err?.message || err);
    return null;
  }
}

export function setJwt(token) {
  try {
    localStorage.setItem("nv_jwt", token);
  } catch (err) {
    // Storage write blocked (private-browsing / quota / disabled). The user
    // can still use the current page session, but a hard reload will lose it.
    // eslint-disable-next-line no-console
    console.warn("session.setJwt: could not persist token —", err?.message || err);
  }
}

export function clearAuthStorage() {
  // Wipe everything related to auth from BOTH storages so a stale tab on
  // another browser cannot resurrect a half-dead session.
  try {
    [...AUTH_LOCAL_KEYS, ...LEGACY_AUTH_KEYS].forEach((k) => {
      localStorage.removeItem(k);
      sessionStorage.removeItem(k);
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn("session.clearAuthStorage: storage unavailable —", err?.message || err);
  }
}
